import { action } from 'satcheljs';

export interface ON_FAVORITES_ParsingCompleteActionMessage {
    favoriteIds: string[];
}
const onFavoriteParsingComplete: (
    favoriteIds: string[]
) => ON_FAVORITES_ParsingCompleteActionMessage = action(
    'ON_FAVORITES_ParsingComplete',
    (favoriteIds: string[]): ON_FAVORITES_ParsingCompleteActionMessage => {
        return {
            favoriteIds,
        };
    }
);
export default onFavoriteParsingComplete;
